type QualarooAction = ["identify", string] | ["showSurvey", string];

declare global {
  interface Window {
    _kiq?: Array<QualarooAction>;
  }
}

// See https://help.qualaroo.com/hc/en-us/articles/206337655-Displaying-surveys-and-nudges-with-the-API
export function identifyUser(userId: string) {
  if (typeof window !== "undefined") {
    window._kiq?.push(["identify", userId]);
  }
}
